function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import featureEnabled from 'shared/helper/feature';
import { getChinaLocalization } from 'shared/account/reducer';
import { useTranslate } from 'shared/helper/translate';
import { PADDLE_PLAN_TYPES } from '../../../constants';
import { trackUpgradeClick } from '../../../helpers/navbarTracking';
import useCardlessTrial from '../../useCardlessTrial';
import BillingToggle from '../components/BillingToggle';
import { PRIMARY_BUTTON } from '../components/buttonClasses';
import PlanCard from '../components/PlanCard';
import PricingLayout from '../components/PricingLayout';
import { FEATURE_LIST_TERMS, GROUP_PLAN_URLS, ROW_CTA_TERMS } from '../pricingContent';
import usePricingCopy from '../usePricingCopy';
import PaddleCheckoutButton from './PaddleCheckoutButton';
import usePricingAnalytics from './usePricingAnalytics';
import usePurchaseCompletion from './usePurchaseCompletion';
import useRowPlanPricing from './useRowPlanPricing';
var ROW_PLANS = [{
  id: 'premium',
  planGroup: 'editing',
  analyticsName: 'Rubriq Premium',
  isPopular: true
}, {
  id: 'translation',
  planGroup: 'premiumWithTranslation',
  analyticsName: 'Rubriq Premium with Translation',
  hiddenWithActivePlan: true
}];
var RowPricingPage = function RowPricingPage(_ref) {
  var hasActivePlan = _ref.hasActivePlan;
  var _useState = useState(PADDLE_PLAN_TYPES.YEARLY),
    _useState2 = _slicedToArray(_useState, 2),
    billingInterval = _useState2[0],
    setBillingInterval = _useState2[1];
  var isChinaUser = useSelector(getChinaLocalization);
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var cardlessTrialEnabled = featureEnabled('rubriq_cardless_free_trial');
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _usePricingCopy = usePricingCopy(),
    page = _usePricingCopy.page,
    plans = _usePricingCopy.plans;
  var _useRowPlanPricing = useRowPlanPricing(),
    getSubscriptionPricing = _useRowPlanPricing.getSubscriptionPricing,
    getOneTimePricing = _useRowPlanPricing.getOneTimePricing;
  var onPurchaseComplete = usePurchaseCompletion();
  var _usePricingAnalytics = usePricingAnalytics({
      hasActivePlan: hasActivePlan
    }),
    trialPlanUsed = _usePricingAnalytics.trialPlanUsed,
    trackBillingIntervalSelected = _usePricingAnalytics.trackBillingIntervalSelected,
    trackCheckoutStarted = _usePricingAnalytics.trackCheckoutStarted,
    trackPlanSelected = _usePricingAnalytics.trackPlanSelected;

  // The plan cards sell the no-trial plans only; the trial itself is started from the navbar.
  // This is here to tell whether the user is on a trial they can buy their way out of.
  var cardlessTrial = useCardlessTrial();
  var isPremiumTrialing = useSelector(function (state) {
    var _state$curie;
    return ((_state$curie = state.curie) === null || _state$curie === void 0 || (_state$curie = _state$curie.plans) === null || _state$curie === void 0 || (_state$curie = _state$curie.premium) === null || _state$curie === void 0 ? void 0 : _state$curie.paymentStatus) === 'trialing';
  });
  var cardlessTrialSubscriptionId = useSelector(function (state) {
    var _state$curie2;
    return (_state$curie2 = state.curie) === null || _state$curie2 === void 0 || (_state$curie2 = _state$curie2.plan) === null || _state$curie2 === void 0 || (_state$curie2 = _state$curie2.paddleSubscription) === null || _state$curie2 === void 0 ? void 0 : _state$curie2.paddleId;
  });
  var isOnCardlessTrial = cardlessTrialEnabled && cardlessTrial.hasCardlessSubscription && (hasActivePlan || isPremiumTrialing);
  var _getSubscriptionPrici = getSubscriptionPricing(ROW_PLANS[0].planGroup, billingInterval),
    discountPercent = _getSubscriptionPrici.discountPercent;
  var billingOptions = [{
    value: PADDLE_PLAN_TYPES.MONTHLY,
    label: page.monthly
  }, {
    value: PADDLE_PLAN_TYPES.YEARLY,
    label: page.annual,
    badge: discountPercent > 0 ? page.discount(discountPercent) : null
  }];
  var handleBillingChange = function handleBillingChange(interval) {
    setBillingInterval(interval);
    trackBillingIntervalSelected(interval);
  };
  var featuresTermById = {
    premium: FEATURE_LIST_TERMS.premium,
    translation: deepSeekEnabled ? FEATURE_LIST_TERMS.translationDeepseek : FEATURE_LIST_TERMS.translation
  };
  var ctaLabelFor = function ctaLabelFor(copy) {
    if (cardlessTrialEnabled) {
      return copy.buttonLabel;
    }
    return t(trialPlanUsed ? ROW_CTA_TERMS.subscribe : ROW_CTA_TERMS.startTrial);
  };
  var renderPlanCard = function renderPlanCard(_ref2) {
    var id = _ref2.id,
      planGroup = _ref2.planGroup,
      analyticsName = _ref2.analyticsName,
      isPopular = _ref2.isPopular;
    var copy = plans[id];
    var _getSubscriptionPrici2 = getSubscriptionPricing(planGroup, billingInterval),
      selectedPlan = _getSubscriptionPrici2.selectedPlan,
      amount = _getSubscriptionPrici2.amount,
      monthlyPrice = _getSubscriptionPrici2.monthlyPrice,
      yearlySavings = _getSubscriptionPrici2.yearlySavings;
    var ctaLabel = ctaLabelFor(copy);
    var action = /*#__PURE__*/React.createElement(PaddleCheckoutButton, {
      paddlePlanId: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.paddlePlanId,
      className: PRIMARY_BUTTON,
      upgradedFromSubscriptionId: isOnCardlessTrial ? cardlessTrialSubscriptionId : undefined,
      onClick: function onClick() {
        if (isOnCardlessTrial) {
          trackUpgradeClick();
        }
        trackCheckoutStarted({
          buttonId: "pricing_checkout_".concat(id),
          productName: analyticsName,
          plan: selectedPlan
        });
      },
      onClose: selectedPlan && onPurchaseComplete({
        plan: selectedPlan,
        amount: amount,
        productName: analyticsName
      })
    }, ctaLabel);
    return /*#__PURE__*/React.createElement(PlanCard, {
      key: id,
      title: copy.title,
      popularBadge: isPopular && page.popular,
      pill: copy.pill,
      price: monthlyPrice,
      period: page.perMonth,
      savingsNote: yearlySavings && page.savings(yearlySavings),
      featuresPrefix: copy.featuresPrefix,
      featuresTerm: featuresTermById[id],
      action: action
    });
  };

  // A cardless trial counts as an active plan, but its whole point is that the user can
  // still move to Translation, so the card stays on the page for them.
  var visiblePlans = ROW_PLANS.filter(function (plan) {
    return isOnCardlessTrial || !(hasActivePlan && plan.hiddenWithActivePlan);
  });
  return /*#__PURE__*/React.createElement(PricingLayout, {
    toggle: /*#__PURE__*/React.createElement(BillingToggle, {
      options: billingOptions,
      value: billingInterval,
      onChange: handleBillingChange
    }),
    planCards: visiblePlans.map(renderPlanCard),
    groupUrl: isChinaUser ? GROUP_PLAN_URLS.china : GROUP_PLAN_URLS.row,
    plagiarism: featureEnabled('rubriq_plagiarism') && {
      price: getOneTimePricing('plagiarism'),
      onSelect: function onSelect() {
        return trackPlanSelected('Plagiarism Check');
      }
    }
  });
};
export default RowPricingPage;